import { Grid } from '@mui/material';
import ProductionCardLoader from './ProductionCardLoader';

const CardLoaderSection = ({ className }: any) => {
  return (
    <>
      <div className={className ? className : `card-loader-sction`}>
        <Grid container rowGap={0} columnSpacing={2}>
          <Grid item lg={3} md={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={3} md={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={3} md={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
          <Grid item lg={3} md={4} xs={12}>
            <ProductionCardLoader />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default CardLoaderSection;
